import React, { Component } from "react";
import { Col, Container, Row } from "reactstrap";
import BatchProyectoTable from "../components/Proyecto/BatchProyectoTable";

class Proyecto_batch extends Component {
  

  render() {
    return (
      <Container style={{ marginTop: "20px" }}>
        <Row>
          <Col>
            <BatchProyectoTable />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Proyecto_batch;